// extracted by mini-css-extract-plugin
export default {"topImage":"inAppMessage_topImage__eqR3J","bottom_text":"inAppMessage_bottom_text__ofbU3"};